module.exports = __webpack_public_path__ + "assets/img/logo3.68ab6ffa.png";